import React from 'react';
import {
   Stack,
   Typography,
   Button,
   IconButton,
   Tooltip
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DownloadIcon from '@mui/icons-material/Download';
import styles from './admin.module.css';
import SearchableInput from './SearchableInput';

/**
 * Admin Header Component
 * Contains title, search input, and action buttons
 */
const AdminHeader = ({
   searchValue = '',
   onSearchChange,
   onAddUser,
   onExportUsers,
   isLoading = false
}) => {
   const [searchFocused, setSearchFocused] = React.useState(false);

   const searchContainer = {
      backgroundColor: '#ffffff',
      padding: '20px',
      borderRadius: '10px',
      marginTop: '10px',
      overflow: 'hidden', // Prevent layout shifts during search field expansion
   };

   return (
      <div style={searchContainer}>
         <Stack direction='row' spacing={4} justifyContent='space-between'>
            <Stack direction='row'>
               <Typography variant="h5" component="h2" fontWeight="500">
                  GSD Users Management
               </Typography>
            </Stack>
            <Stack direction='row' spacing={searchFocused ? 3 : 2} sx={{ transition: 'all 0.3s ease-in-out' }}>
               <SearchableInput
                  onSearch={onSearchChange}
                  placeholder="Search users..."
                  initialValue={searchValue}
                  isLoading={isLoading}
                  className={styles.searchField}
                  onFocus={() => setSearchFocused(true)}
                  onBlur={() => setSearchFocused(false)}
                  fullWidth
               />
               <Button 
                  variant="contained" 
                  color="primary" 
                  startIcon={<PersonAddIcon />}
                  onClick={onAddUser}
                  className={styles.addUserButton}
               >
                  Add User
               </Button>
               <IconButton
                  className={styles.exportButton}
                  size="medium"
                  onClick={onExportUsers}
               >
                  <Tooltip title="Export Users">
                     <DownloadIcon />
                  </Tooltip>
               </IconButton>
            </Stack>
        </Stack>
      </div>
   );
};

export default AdminHeader;
